<template>
	<div>
		<headerSouthernEn></headerSouthernEn>
		<appMain></appMain>
		<footers></footers>
	</div>
</template>
<script>
import headerSouthernEn from './components/headerSouthernEn.vue';
import appMain from './components/appMain.vue';
import footers from './components/footerSouthernEn.vue';
import { mapMutations } from 'vuex';
import { getNavSouthern } from '../api/home';
export default {
	name: '',
	components: {
		appMain,
		footers,
		headerSouthernEn,
	},
	mixins: [],
	props: {},
	data() {
		return {
			assemblyList: [],
			isMoblie: false,
		};
	},
	computed: {},
	watch: {
		MobileVerification: {
			handler(to) {
				// ////console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {
		//因为移动端需要在首页获取重点专题库的内容  但是在打开抽屉之前第调用不到导航接口  所以只能在组件入口发放接口内容.
		// if (this.isMoblie == true) {
		// 	let _this = this;
		// 	getNavSouthern({ uid: 'A7', depth: '0' }).then((res) => {
		// 		_this.updateHomeNavList(res.data.data);
		// 	});
		// }
	},
	methods: {
		...mapMutations(['updateHomeNavList']),
	},
	beforeDestroy() {
		//组件销毁前要解绑事件
		this.$eventBus.$off('bustype1');
		this.$eventBus.$off('literatureList');
		this.$eventBus.$off('upLists');
	},
};
</script>
<style lang="less" scoped>
.add {
	position: absolute;
	right: 0;
	top: 60px;
}
@media screen and (max-width: 769px) {
	.add {
		position: absolute;
		right: 0;
		top: 112px !important;
		bottom: 0px !important;
		display: flex;
	}
	.header {
		height: 144px !important;
	}
}
</style>
